import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH, variables } from 'src/Styled/variables'
import Exclamation from 'src/Assets/Svg/exclamation-round.svg?react'
import { RedButton } from 'src/Components/Buttons/RedButton'

import { DeleteAccountModal } from '../../DeleteAccountModal'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  margin-top: 40px;
  @media (min-width: ${MAX_MOBILE_WIDTH}) {
    margin-top: 24px;
  }
`

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  justify-self: center;
  align-self: center;
  color: ${({ theme }) => theme.color.mediumRed};
`

const Title = styled.h2`
  margin: 0;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize18};
  font-style: normal;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
`

const Description = styled.p`
  margin: 0;
  font-family: 'Segoe UI';
  font-size: ${variables.fontSize14};
  font-style: normal;
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  color: ${({ theme }) => theme.color.darkGrey};
  max-width: 600px;
  text-align: center;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

interface DeleteAccountTabProps {
  modal: boolean
  modalToggle: () => void
}

export const DeleteAccountTab: FC<DeleteAccountTabProps> = ({
  modalToggle,
  modal,
}) => (
  <>
    <Container>
      <IconWrapper>
        <Exclamation width={40} height={40} />
      </IconWrapper>

      <TextContainer>
        <Title>Are you sure you want to delete your account?</Title>
        <Description>
          You'll lose access to your SoundCampaign account, meaning you'll no
          longer be able to manage your account or interact on our platform.
        </Description>
      </TextContainer>

      <RedButton type='button' onClick={modalToggle}>
        Delete account
      </RedButton>
    </Container>
    <DeleteAccountModal visible={modal} toggleModalVisible={modalToggle} />
  </>
)
